<template>
  <div>
    <v-dialog v-bind:value="value"
              v-on:input="$emit('input', $event)"
              width="480">
      <v-card>
        <v-card-title>
          {{ title }}
        </v-card-title>
        <v-card-text>
          {{ message }}
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn text
                 v-on:click="cancel">
            {{ cancelButtonLabel }}
          </v-btn>
          <v-btn color="primary"
                 depressed
                 v-on:click="confirm">
            {{ confirmButtonLabel }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  export default {
    data: () => ({
      resolve: null
    }),
    methods: {
      cancel() {
        this.$emit('input', false)
        this.resolve(false)
      },
      confirm() {
        this.$emit('input', false)
        this.$emit('confirm')
        this.resolve(true)
      },
      async open(resolve) {
        this.resolve = resolve
        this.$emit('input', true)
      }
    },
    name: 'InfoDialog',
    props: {
      cancelButtonLabel: String,
      confirmButtonLabel: String,
      message: String,
      title: String,
      value: Boolean
    }
  }
</script>
